import ReactCountryFlag from "react-country-flag";
import IntelLayout from "../../components/layout/layout";
import commaFormat from "@utils/commaFormat";
import { useEffect, useState } from "react";
import axios from "axios";
import { getApiUrl } from "@utils/baseUrl";
import moment from "moment";
import { Modal } from "react-bootstrap";
import LoadingSkeleton from "@shared/LoadingSkeleton";
import LocalStorageService from "@core/services/local-storage.service";
import { toast } from "react-toastify";
import { captureException } from "@sentry/react";
import { DATASET_TYPE_MAPPING, SHIPMENT_DATASET_DISPLAY_NAME_OVERRIDES } from "@/core/dictionary/global";

type DataUpdate = {
  id: string | number;
  country: string;
  country_code: string;
  product_id: string;
  trade_direction: string;
  is_subscribe: boolean;
  shipment_text: string;
  company_text: string;
  shipments: number;
  companies: number;
  latest_arrival_date: string;
};

const SKELETON_CARD_COUNT = 6;

const DataUpdates = () => {
  const [dataUpdatesData, setDataUpdatesData] = useState<DataUpdate[]>([]);
  const [showNotification, setShowNotification] = useState(false);
  const [getInTouchPopUp, setGetInTouchPopUp] = useState(false);
  const [loading, setLoading] = useState(true);
  const [unsubscribedCOuntry, setUnsubscribedCountry] = useState("");
  const localStorageService = LocalStorageService.getService();
  const getDataUpdates = async () => {
    try {
      const { data } = await axios.post(getApiUrl("userDashboard"), { section_type: "data_updates", from: 0 });
      if (data && data.dataUpdates && data.dataUpdates.data) {
        setDataUpdatesData(data.dataUpdates.data);
      }
    } catch {
      setDataUpdatesData([]);
    } finally {
      setLoading(false);
    }
  };
  const handleGetInTouchSubmit = () => {
    const params = {
      planId: localStorageService && localStorageService.getUserCurrentPlan() ? localStorageService.getUserCurrentPlan() : "",
      countries: unsubscribedCOuntry,
      key: "Data Updates",
    };
    axios
      .get(getApiUrl("notifySales"), { params })
      .then((res) => {
        if (!!res && !!res.data && !!res.data.status && res.data.status.toUpperCase() === "success".toUpperCase()) {
          toast.success(res.data.message);
          setGetInTouchPopUp(false);
        } else {
          toast.error(res.data.message ? res.data.message : "Something went wrong. Please try again later !!!");
        }
      })
      .catch((err) => {
        captureException(err);
        setGetInTouchPopUp(false);
        toast.error("Something went wrong. Please try again later !!!");
      });
  };

  useEffect(() => {
    getDataUpdates();
  }, []);
  return (
    <IntelLayout
      type={"Data Updates"}
      pageTitle="Data Updates | Trademo Intel"
      setNotification={(val) => {
        setShowNotification(val);
      }}
      showNotification={showNotification}>
      <div className="py-3">
        <div className="tw-grid tw-grid-cols-[repeat(2,auto)] tw-justify-center tw-gap-6 tw-w-full tw-max-w-[1440px] tw-mx-auto tw-p-5">
          {loading
            ? Array.from({ length: SKELETON_CARD_COUNT }, (_, index) => (
                <div className="tw-flex tw-flex-col tw-gap-5 tw-p-5 tw-w-[45%] tw-min-w-[440px] tw-max-w-[560px] tw-rounded-lg tw-shadow-sm tw-border tw-border-solid tw-border-gray-200" key={index}>
                  <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-w-full">
                    <div className="tw-flex tw-items-center tw-gap-2">
                      <LoadingSkeleton width="40px" height="40px" shape="circle" />
                      <div className="tw-flex tw-flex-col tw-gap-1.5">
                        <LoadingSkeleton width="160px" height="14px" />
                        <LoadingSkeleton width="70px" height="14px" />
                      </div>
                    </div>
                    <LoadingSkeleton width="96px" height="24px" />
                  </div>
                  <div className="tw-grid tw-grid-cols-2 tw-gap-4 tw-w-full">
                    {[0, 1].map((stat) => (
                      <div className="tw-flex tw-flex-col tw-gap-2" key={stat}>
                        <LoadingSkeleton width="120px" height="30px" />
                        <LoadingSkeleton width="100%" height="14px" />
                      </div>
                    ))}
                  </div>
                  <div className="tw-w-full tw-pt-4 tw-border-t tw-border-solid tw-border-gray-200">
                    <LoadingSkeleton width="150px" height="12px" />
                  </div>
                </div>
              ))
            : dataUpdatesData.map((dataUpdate) => (
                <div className="tw-flex tw-flex-col tw-gap-5 tw-p-5 tw-rounded-lg tw-shadow-sm tw-border tw-border-solid tw-border-gray-200" key={dataUpdate.id}>
                  <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-w-full">
                    <div className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-medium tw-text-gray-900">
                      <div className="tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-w-10 tw-h-10 tw-rounded-full tw-border tw-border-solid tw-border-gray-200">
                        <ReactCountryFlag countryCode={dataUpdate.country_code?.slice(0, 2)} svg />
                      </div>
                      <div>
                        {`${SHIPMENT_DATASET_DISPLAY_NAME_OVERRIDES[dataUpdate.country?.toLowerCase()] || dataUpdate.country || ""} ${DATASET_TYPE_MAPPING[`${dataUpdate?.country_code?.toLowerCase()}_${dataUpdate?.trade_direction?.toLowerCase()?.endsWith("s") ? dataUpdate?.trade_direction?.toLowerCase()?.slice(0, -1) : dataUpdate?.trade_direction?.toLowerCase()}`] || ""}`}
                        <div className="tw-font-normal">{dataUpdate.trade_direction}</div>
                      </div>
                    </div>
                    {dataUpdate.is_subscribe ? (
                      <div className="tw-flex tw-items-center tw-gap-1.5 tw-px-1.5 tw-py-0.5 tw-text-sm tw-rounded-[14px] tw-whitespace-nowrap tw-bg-[#ecfdf3]">
                        Subscribed <span className="material-symbols-outlined">new_releases</span>
                      </div>
                    ) : (
                      <div
                        className="tw-flex tw-items-center tw-gap-1.5 tw-px-1.5 tw-py-0.5 tw-text-sm tw-rounded-[14px] tw-whitespace-nowrap tw-cursor-pointer tw-text-[#dc6803] tw-bg-[#fffaeb]"
                        onClick={() => {
                          setGetInTouchPopUp(true);
                          setUnsubscribedCountry(dataUpdate.country);
                        }}>
                        Subscribe <span className="material-symbols-outlined">bolt</span>
                      </div>
                    )}
                  </div>
                  <div className="tw-grid tw-grid-cols-2 tw-gap-4 tw-w-full">
                    <div>
                      <div className={`tw-text-2xl tw-font-semibold tw-leading-tight ${dataUpdate.is_subscribe ? "tw-text-gray-900" : "tw-text-gray-400"}`}>{commaFormat(dataUpdate.shipments)}</div>
                      <div className="tw-text-sm tw-font-medium tw-text-gray-900">{dataUpdate.shipment_text}</div>
                    </div>
                    <div>
                      <div className={`tw-text-2xl tw-font-semibold tw-leading-tight ${dataUpdate.is_subscribe ? "tw-text-gray-900" : "tw-text-gray-400"}`}>{commaFormat(dataUpdate.companies)}</div>
                      <div className="tw-text-sm tw-font-medium tw-text-gray-900">{dataUpdate.company_text}</div>
                    </div>
                  </div>
                  <div className="tw-flex tw-flex-col tw-gap-3 tw-w-full tw-pt-4 tw-border-t tw-border-solid tw-border-gray-200">
                    <div className="tw-text-xs tw-text-gray-500">Last updated on {moment(dataUpdate.latest_arrival_date).format("MMM DD, YYYY")}</div>
                    {dataUpdate.product_id === "trademo_MX" && <div className="tw-text-xs tw-leading-5 tw-text-gray-500 tw-bg-gray-50 tw-rounded-md tw-px-3 tw-py-2">Mexico data is only available only available on the platform from 2020 onwards. Data from 2011 to 2019 is also available upon request via Customer Success.</div>}
                  </div>
                </div>
              ))}
        </div>
        {getInTouchPopUp ? (
          <Modal show={getInTouchPopUp} onHide={() => setGetInTouchPopUp(false)} keyboard={false} centered className="trademo-modal company-profile-get-in-touch-modal">
            <Modal.Header>
              <Modal.Title>
                <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684478309/intel/icons/Lightning-alt_t9mkjb.svg" />
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>You do not have access to this data set. Connect with your account manager to get access.</Modal.Body>
            <Modal.Footer>
              <button type="button" className="btn btn-secondary" onClick={() => setGetInTouchPopUp(false)}>
                Cancel
              </button>
              <button type="button" className="btn btn-primary trademo-new-btn" onClick={handleGetInTouchSubmit}>
                Get in Touch
              </button>
            </Modal.Footer>
          </Modal>
        ) : (
          <></>
        )}
      </div>
    </IntelLayout>
  );
};

export default DataUpdates;
